// src/context/DarkModeContext.js
import { createContext, useContext, useState, useEffect } from "react";

const DarkModeContext = createContext();

export function useDarkMode() {
  return useContext(DarkModeContext);
}

export function DarkModeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("darkMode") === "true";
  });

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
    document.body.style.background = darkMode ? "#0f172a" : "";
  }, [darkMode]);

  function toggleDarkMode() {
    setDarkMode(v => !v);
  }

  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </DarkModeContext.Provider>
  );
}

// Dark mode color tokens
export const DM = {
  // Backgrounds
  pageBg: (d) => d ? "#0f172a" : "#f4f6fb",
  cardBg: (d) => d ? "#1e293b" : "#fff",
  headerBg: (d) => d ? "linear-gradient(135deg, #020617, #0f172a, #1e293b)" : "linear-gradient(135deg, #0f2557, #1a3a8f, #2563eb)",
  sidebarBg: (d) => d ? "#1e293b" : "#fff",
  inputBg: (d) => d ? "#0f172a" : "#f8fafc",
  inputBorder: (d) => d ? "#334155" : "#e2e8f0",
  // Text
  textPrimary: (d) => d ? "#f1f5f9" : "#1e293b",
  textSecondary: (d) => d ? "#94a3b8" : "#475569",
  textMuted: (d) => d ? "#64748b" : "#94a3b8",
  // Borders
  border: (d) => d ? "#334155" : "#f1f5f9",
  // Shadows
  shadow: (d) => d ? "0 2px 12px rgba(0,0,0,0.4)" : "0 2px 12px rgba(15,37,87,0.07)",
};
